// extracted by mini-css-extract-plugin
export default {"megaSicBacTableBody":"vO_vP","megaSicBacTableHead":"vO_vQ","win":"vO_uK","refunded":"vO_uO","boosted":"vO_vR"};